import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import styled from "@emotion/styled";
import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";
import { useNavigate } from "react-router-dom";

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export default function EndcustomerArticlesCombobox({
  label,
  endcustomerArticles,
  selectedArticleID,
  onChange,
}) {
  const navigate = useNavigate();

  return (
    <StyledAutocomplete
      disablePortal
      value={
        endcustomerArticles
          ? endcustomerArticles.find((a) => a.Id === selectedArticleID)
          : null
      }
      options={endcustomerArticles ? endcustomerArticles : []}
      getOptionLabel={(a) => a.Id + "-" + a.Name}
      isOptionEqualToValue={(option, value) => {
        return option.Id === value?.Id || value == null;
      }}
      onChange={(event, newValue) => {
        onChange(newValue == null ? null : newValue.Id);
      }}
      fullWidth
      margin="dense"
      size="small"
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment
                position="start"
                sx={{
                  display: selectedArticleID != null ? "flex" : "none",
                }}
              >
                <IconButton
                  onClick={() =>
                    navigate(`/endcustomersarticles/${selectedArticleID}`)
                  }
                  edge="end"
                >
                  {<LinkIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          label={label ? label : ""}
        />
      )}
    />
  );
}
